<template>
  <div class="stream">
    <blocks-container
      :blocks="blocks"
      :unlock="unlock"
      @init="handleContainerInit"
    />
  </div>
</template>

<script>
import BlocksContainer from "@/components/stream/BlocksContainer"

export default {
  components: {
    BlocksContainer
  },

  props: {
    blocks: { type: Array, required: true },
    unlock: { type: Boolean, default: false }
  },

  methods: {
    handleContainerInit() {
      this.$emit("blocksRendered")
    }
  }
}
</script>
